import { settingsApi, VpnSettingValue } from '@cloud/shared';

export async function getSettingBulk(settingTypeList: VpnSettingValue[]) {
    const settingList: { setting: VpnSettingValue; value: any }[] = await settingsApi.get(
        '/settings',
        { keys: settingTypeList.join(',') },
    );

    return settingList.reduce(
        (acc, t) => {
            acc[t.setting] = t.value;
            return acc;
        },
        {} as Record<VpnSettingValue, any>,
    );
}
